export const DynamicFormsPermission = {
  Dashboard: 1,
  ViewForms: 2,
  CreateForms: 4,
  EditForms: 8,
  ViewSubmissions: 16,
  ManageSubmissions: 32,
  ViewReports: 64,
  ManageReports: 128,
  ManageSettings: 256
} as const;

export interface AccessContext {
  IsAdministrator: boolean;
  IsSuperUser: boolean;
  GlobalPermissionMask: number;
  FormPermissionMasks: Record<string, number>;
  CanAccessDashboard: boolean;
  CanViewForms: boolean;
  CanCreateForms: boolean;
  CanEditAnyForm: boolean;
  CanViewAnySubmissions: boolean;
  CanManageAnySubmissions: boolean;
  CanViewAnyReports: boolean;
  CanManageAnyReports: boolean;
  CanManageSettings: boolean;
  CanManageAccess: boolean;
  CanManagePackages: boolean;
  CanManagePortalFeatures: boolean;
  CanManageSmsSettings: boolean;
  CanToggleSms: boolean;
  CanCloneForms: boolean;
  CanDeleteForms: boolean;
  MaxForms?: number | null;
  FormCount: number;
  EffectiveFeatures: string[];
}

export interface AccessPolicy {
  ID: number;
  PortalID: number;
  PrincipalType: 1 | 2;
  PrincipalID: number;
  PrincipalName: string;
  FormID?: number | null;
  FormTitle?: string;
  PermissionMask: number;
  CreatedOn: string;
  CreatedBy: number;
  ModifiedOn?: string | null;
  ModifiedBy?: number | null;
}

export interface AccessPrincipal {
  PrincipalType: 1 | 2;
  PrincipalID: number;
  Name: string;
  SecondaryText: string;
}

export interface AccessForm {
  FormID: number;
  Title: string;
}

export interface SaveAccessPolicy {
  ID?: number;
  PrincipalType: 1 | 2;
  PrincipalID: number;
  FormID?: number | null;
  PermissionMask: number;
}
